import {
  ALLOWED_PRODUCT_DOCUMENT_TYPES,
  BomItem,
  ProductDetail,
  ProductDocument,
  ProductDocumentType,
} from '@vi-succ/products-domain';
import { ApiProductDetail, ProductDetailDocument } from '../entity';
import { environment } from '../environments/environment';
import { ProductImageFactory } from './product-image.factory';

export class ProductDetailFactory {
  static build(hit: ApiProductDetail): ProductDetail {
    const imageFactory = new ProductImageFactory(environment.backend.resourcesUrl);
    const findDoc = (docs: ProductDetailDocument[]) => {
      return (docs ?? [])
        .filter((doc) => ALLOWED_PRODUCT_DOCUMENT_TYPES.includes(doc.documentType as ProductDocumentType))
        .map((document) => {
          const doc: ProductDocument = {
            documentPart: document.documentPart,
            documentType: document.documentType as ProductDocumentType,
            fileName: document.fileName,
          };
          return doc;
        });
    };
    const documents = findDoc(hit.documents);

    const bom = (hit.bom ?? []).map((bomItem) => {
      const b: BomItem = {
        amount: bomItem.amount,
        // TODO: Add details
        documents: bomItem.documents,
        grossPrice: bomItem.conditionValue ?? bomItem.grossPrice,
        currency: bomItem.conditionUnit ?? bomItem.currency ?? hit.currency,
        isSparePart: bomItem.sparePart,
        isWearPart: bomItem.wearPart,
        isSales: bomItem.sellable,
        materialDescription: bomItem.shortText,
        materialNumber: bomItem.materialNumber,
        positionNumber: bomItem.posNr,
        unitOfMeasure: bomItem.unit,
        materialType: bomItem.materialType,
        isIbau: bomItem.materialType === 'IBAU',
        isBaseDevice: bomItem.positionTypeGroup === 'LUMF',
        productImages: imageFactory.build(bomItem.documents),
        sellableHint: bomItem.sellableHint,
        showPrice: bomItem.showPrice,
        showAvailability: bomItem.showAvailability,
        shoppingCartState: bomItem.shoppingCartState,
      };
      return b;
    });

    return {
      bom,
      currency: hit.conditionUnit as string,
      documents,
      features: hit.features,
      grossPrice: hit.conditionValue ?? 0,
      materialDescription: hit.shortText,
      materialLongDescription: hit.longText,
      materialGroup: hit.materialGroup,
      netPrice: 0,
      originalObject: hit,
      sparePart: hit.sparePart,
      // TODO: Add details
      wearPart: hit.wearPart,
      ibau: hit.materialType === 'IBAU',
      sales: hit.sellable,
      baseDevice: hit.positionTypeGroup === 'LUMF',
      materialNumber: hit.materialNumber,
      materialType: hit.materialType,
      productImages: imageFactory.build(hit.documents),
      shoppingCartState: hit.shoppingCartState,
      showPrice: hit.showPrice,
      sellableHint: hit.sellableHint,
      showAvailability: hit.showAvailability,
    };
  }
}
